/// <amd-module name="Wit/DirectoryView/Components/DirectoryFavoriteButton" />
import { FavoriteCreateParameters } from "Favorites/Common/Contracts/Favorite";
import { IFavoritesService } from "Favorites/Common/FavoritesService";
import { FavoritesStar } from "Favorites/Star/FavoritesStar";
import * as React from "react";
import { TfsComponent } from "Tfs/Platform/TfsComponent";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { DirectoryItem } from "Wit/DirectoryService/Client/Contracts/Directory";

export interface IDirectoryFavoriteButtonProps {
    artifactType: string;
    buttonClassName?: string;
    className?: string;
    item: DirectoryItem;
    onAddFavorite?: (event?: React.MouseEvent<any>) => void;
    onRemoveFavorite?: (event?: React.MouseEvent<any>) => void;
}

const DirectoryFavoriteScope = "Project";

export class DirectoryFavoriteButton extends TfsComponent<IDirectoryFavoriteButtonProps> {
    private favoritesService: IFavoritesService;

    constructor(props: IDirectoryFavoriteButtonProps, context: IVssComponentContext) {
        super(props, context);
        this.favoritesService = context.pageContext.getService<IFavoritesService>("IFavoritesService");
    }

    public render() {
        if (!this.favoritesService.canUseFavorites()) {
            return null;
        }

        const favorite = {
            artifactId: this.props.item.id,
            artifactName: this.props.item.name,
            artifactType: this.props.artifactType,
            artifactScope: {
                id: this.projectData?.id,
                name: this.projectData?.name,
                type: DirectoryFavoriteScope
            }
        } as FavoriteCreateParameters;

        return (
            <FavoritesStar
                artifact={favorite}
                buttonClassName={this.props.buttonClassName}
                className={this.props.className}
                onAddFavorite={event => this.toggleFavorite(event, this.props.onAddFavorite)}
                onRemoveFavorite={event => this.toggleFavorite(event, this.props.onRemoveFavorite)}
            />
        );
    }

    private toggleFavorite(event?: React.MouseEvent<any>, action?: (event?: React.MouseEvent<any, MouseEvent> | undefined) => void) {
        event?.preventDefault();
        action && action();
    }
}
